import { useEffect } from 'react';
import { AppLink } from '@/components/AppLink';
import { Button } from '@/components/Button';
import { Card, CARD_TITLE } from '@/components/Card';
import { Container } from '@/components/Container';
import { PageHeader } from '@/components/PageHeader';

const LINKS = [
  ['Notice board', '/notices'],
  ['Courses & syllabi', '/courses'],
  ['Examinations', '/examinations'],
  ["Student's E-Journal", '/e-journal'],
  ['Contact', '/contact'],
] as const;

export function NotFound() {
  // Tell search engines not to index an error page that the server cannot mark as 404 itself.
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return (
    <>
      <PageHeader
        title="Page not found"
        intro="We could not find that page. It may have moved, or the address may have been typed differently."
      />
      <Container className="pt-[clamp(32px,5vw,56px)] pb-[clamp(56px,7vw,96px)]">
        <Card as="section" aria-labelledby="h-next" className="max-w-[560px]">
          <h2 id="h-next" className={CARD_TITLE}>Where would you like to go?</h2>
          <ul className="m-0 list-none border-t border-rule p-0">
            {LINKS.map(([label, to]) => (
              <li key={to} className="border-b border-rule">
                <AppLink
                  href={to}
                  className="flex items-baseline justify-between py-[13px] font-semibold text-ink no-underline hover:text-teal-700"
                >
                  {label}
                  <span aria-hidden="true" className="text-teal-700">→</span>
                </AppLink>
              </li>
            ))}
          </ul>
          <Button href="/" className="mt-6">Go to the homepage</Button>
        </Card>
      </Container>
    </>
  );
}
